import { render } from "./A5Form.vue?vue&type=template&id=2715f219&scoped=true"
import script from "./A5Form.vue?vue&type=script&lang=js"
export * from "./A5Form.vue?vue&type=script&lang=js"

import "./A5Form.vue?vue&type=style&index=0&id=2715f219&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2715f219"]])

export default __exports__